import React, { useCallback, useState } from 'react';

import { useTranslation } from '@lyearn/i18n';
import { Modal } from '@/components/Modals';
import { ModalVariant } from '@/components/Modals/types';
import Tabs from '@/components/Tabs';

import { BaseRestrictedVisibilitySettingsModalProps, ModalTabsId } from './types';

const BaseRestrictedVisibilitySettingsModal: React.FC<
  BaseRestrictedVisibilitySettingsModalProps
> = (props) => {
  useTranslation(['Group']);
  const { value, onClose, onChange, disabled, header, action, tabs } = props;

  const [duplicatedValue, onChangeDuplicatedValue] = useState(value);
  const [currentTab, setCurrentTab] = useState(tabs[0].value);

  const onSubmit = useCallback(() => {
    onChange(duplicatedValue);
    onClose();
  }, [duplicatedValue, onChange, onClose]);

  return (
    <Modal
      action={{ ...action, onSubmit }}
      header={header}
      variant={ModalVariant.FullHeight}
      onClose={onClose}>
      {tabs.length > 1 ? (
        <Tabs<ModalTabsId>
          className="mx-8 mb-20 px-24 pt-8"
          tabs={tabs}
          value={currentTab}
          onChange={setCurrentTab}
        />
      ) : null}
      {tabs
        .find(({ value }) => value === currentTab)
        ?.renderer({
          value: duplicatedValue,
          onChange: onChangeDuplicatedValue,
          disabled,
        })}
    </Modal>
  );
};

export default BaseRestrictedVisibilitySettingsModal;
